export default "/images/vendor/blueimp-gallery/loading.gif?430fc2eb2b9556d6f006db257b282429";